module.exports = __webpack_public_path__ + "img/community.353ce6d9.png";